export const convertirDatos = (data) => {
  const mapa = crearMap(data);
  const salida = crearSalida(data, mapa);
  asignarClaves(salida);
  return salida;
};

const crearMap = (data) => {
  const mapa = {};
  data.forEach((item) => {
    mapa[item.IdentificadorCuenta] = {
      data: {
        ...item,
        BalancePeriodoActualAcumulado: 0,
        BalancePeriodoAnteriorAcumulado: 0,
      },
      children: [],
    };
  });
  return mapa;
};

const crearSalida = (data, mapa) => {
  const salida = [];
  data.forEach((item) => {
    if (item.CuentaPadre === 0 || item.CuentaPadre === null) {
      salida.push(mapa[item.IdentificadorCuenta]);
    } else {
      if (mapa[item.CuentaPadre]) {
        agregarHijoPadre(mapa, item);
      }
    }
  });
  return salida;
};

const agregarHijoPadre = (mapa, item) => {
  mapa[item.CuentaPadre].children.push(mapa[item.IdentificadorCuenta]);
  mapa[item.CuentaPadre].data.BalancePeriodoActualAcumulado +=
    item.BalancePeriodoActual || 0;
  mapa[item.CuentaPadre].data.BalancePeriodoAnteriorAcumulado +=
    item.BalancePeriodoAnterior || 0;
};

const asignarClaves = (salida) => {
  salida.forEach((nodo, index) => {
    asignarClaveNodo(nodo, `${index}`);
  });
};

const asignarClaveNodo = (nodo, clavePadre, nivel = 0) => {
  const key =
    nodo.data.CuentaPadre === 0
      ? `${clavePadre}`
      : `${clavePadre}-${nodo.data.IdentificadorCuenta}`;
  nodo.key = key;
  nodo.children.forEach((child, index) =>
    asignarClaveNodo(child, key, nivel + 1)
  );
  if (nivel > -1 && nodo.children.length > 0) {
    agregarTotalHijo(nodo, key);
  }
};

const agregarTotalHijo = (nodo, key) => {
  nodo.children.push({
    data: {
      IdentificadorCuenta: "resultado",
      CuentaDesc: `TOTAL ${nodo.data.Nombre}`,
      BalancePeriodoActual: nodo.data.BalancePeriodoActualAcumulado,
      BalancePeriodoAnterior: nodo.data.BalancePeriodoAnteriorAcumulado,
    },
    key: `${key}-resultado`,
    children: [],
  });
};
